(function () {
  var root = document.querySelector('[data-my-projects]');
  if (!root) return;

  var PROXY_PATH = root.getAttribute('data-mp-proxy-path');
  var CUSTOMER_ID = root.getAttribute('data-mp-customer-id');

  if (window.MSGProjects) {
    window.MSGProjects.setCustomer(CUSTOMER_ID);
  }

  var lockedBlock = root.querySelector('[data-mp-locked]');
  var lockedText = root.querySelector('[data-mp-locked-text]');
  var contentBlock = root.querySelector('[data-mp-content]');
  var emptyBlock = root.querySelector('[data-mp-empty]');
  var homesListEl = root.querySelector('[data-mp-homes-list]');
  var listEl = root.querySelector('[data-mp-project-list]');
  var newHomeNameInput = root.querySelector('[data-mp-new-home-name]');
  var newHomeCreateBtn = root.querySelector('[data-mp-new-home-create]');
  var legacyPrompt = root.querySelector('[data-mp-legacy-prompt]');
  var legacyImportBtn = root.querySelector('[data-mp-legacy-import]');
  var legacyDismissBtn = root.querySelector('[data-mp-legacy-dismiss]');
  var errorEl = root.querySelector('[data-mp-error]');
  var storageDisclosureEl = root.querySelector('[data-mp-storage-disclosure]');
  var migrationContainer = root.querySelector('[data-mp-migration]');

  // Phase 6B #3: what this page learned about the account when it loaded.
  // writes: 'on' | 'off' | 'unknown' (only 'on' allows account writes).
  var pageView = { writes: 'unknown', readFailed: false };

  function accountWrites() {
    return window.MSGProjects && typeof window.MSGProjects.getAccountWrites === 'function'
      ? window.MSGProjects.getAccountWrites()
      : 'unknown';
  }

  function deviceApi() {
    return window.MSGProjects && window.MSGProjects.device ? window.MSGProjects.device : null;
  }

  // Where "+ Create a Home" saves right now.
  //   'account' -- account view, account saving confirmed on
  //   'device'  -- account view, account saving off/unknown (browser copy)
  //   'local'   -- this page is showing this device's Projects only
  function createDestination() {
    if (!cloudSnapshotActive()) return 'local';
    return accountWrites() === 'on' ? 'account' : 'device';
  }

  function showError(message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  // Phase 6B #3: an error line with one follow-up button (e.g. "Create it on
  // this device instead"). Nothing happens unless the customer taps it.
  function showErrorWithAction(message, label, onClick) {
    if (!errorEl) return;
    errorEl.textContent = message + ' ';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mp-error-action';
    btn.setAttribute('data-mp-error-action', '');
    btn.textContent = label;
    btn.addEventListener('click', onClick);
    errorEl.appendChild(btn);
    errorEl.hidden = false;
  }

  function clearError() {
    if (!errorEl) return;
    errorEl.hidden = true;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str || '';
    return div.innerHTML;
  }

  // Polish #13: a browser (localStorage) date that cannot be a real save time
  // -- not a number, before 2008, or in the future -- is shown as
  // "Date unknown" instead of e.g. "December 31, 1969". Same bounds as the
  // import's date rules (lib/validation/import-dates.js). Account (cloud)
  // records keep the original display unchanged.
  var POSSIBLE_FROM_MS = Date.UTC(2008, 0, 1);
  var FUTURE_TOLERANCE_MS = 5 * 60 * 1000;

  function isPossibleBrowserDate(ts) {
    return typeof ts === 'number' &&
      isFinite(ts) &&
      ts >= POSSIBLE_FROM_MS &&
      ts <= Date.now() + FUTURE_TOLERANCE_MS;
  }

  function updatedLabel(project, src) {
    var browserRecord = src === 'device' || !cloudSnapshotActive();
    if (browserRecord && !isPossibleBrowserDate(project.updatedAt)) {
      return 'Date unknown';
    }
    var formatted = formatDate(project.updatedAt); // formatted once
    return 'Updated ' + formatted;
  }

  function formatDate(ts) {
    try {
      return new Date(ts).toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
      });
    } catch (e) {
      return '';
    }
  }

  function cloudSnapshotActive() {
    return !!(
      window.MSGProjects &&
      typeof window.MSGProjects.hasCloudSnapshot === 'function' &&
      window.MSGProjects.hasCloudSnapshot()
    );
  }

  // ============================================================
  // Phase 6A-5: conflict-aware cloud writes on My Projects
  // ============================================================
  //
  // Rules (approved Phase 6A design):
  //   - A 409 updates this page's copy of the record first.
  //   - Home assignment is resent at most once, and only when the
  //     Project's Home is unchanged in the current record.
  //   - Deletes are never resent. After a conflicted delete the customer
  //     sees what changed and deletes again only if they still want to.
  //   - A 409, a network failure or a 5xx is never described as done.
  //   - Only one cloud change runs at a time on this page; the controls are
  //     disabled until it finishes.
  //   - Nothing is written to localStorage or sessionStorage.

  var cloudWriteBusy = false;

  function recoveryApi() {
    return window.MSGCloudProjects && window.MSGCloudProjects.recovery
      ? window.MSGCloudProjects.recovery
      : null;
  }

  function applyCloudBusy() {
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-mp-delete], [data-mp-home-delete], [data-mp-home-select]'),
      function (el) {
        el.disabled = cloudWriteBusy;
      }
    );
    if (newHomeCreateBtn) newHomeCreateBtn.disabled = cloudWriteBusy;
    // Phase 6C: rename controls also depend on their own state.
    refreshRenameAvailability();
  }

  function setCloudBusy(on) {
    cloudWriteBusy = on;
    applyCloudBusy();
  }

  // Runs one cloud change. `work` returns a promise for
  // { render: boolean, message: string | null }.
  function runCloudWrite(work) {
    if (cloudWriteBusy) return;
    setCloudBusy(true);
    var finish = function (report) {
      setCloudBusy(false);
      if (report && report.render) renderAll();
      if (report && report.pausedCreate) {
        offerDeviceHome(report.pausedCreate);
        return;
      }
      if (report && report.message) showError(report.message);
      else clearError();
    };
    Promise.resolve()
      .then(work)
      .then(finish, function () {
        finish({ render: true, message: "We couldn't finish that change. Please refresh the page before trying again." });
      });
  }

  function findProject(projectId) {
    return window.MSGProjects.getProjects().filter(function (p) {
      return p && p.id === projectId;
    })[0] || null;
  }

  function findHome(homeId) {
    return window.MSGProjects.getHomes().filter(function (h) {
      return h && h.id === homeId;
    })[0] || null;
  }

  function homeLabel(homeId) {
    var home = homeId ? findHome(homeId) : null;
    return home ? '“' + home.name + '”' : 'a different Home';
  }

  // Message for definite failures that aren't conflicts or 404s, or null.
  function accountFailureMessage(status) {
    if (status === 'not_entitled') {
      return 'Changing Projects requires an active Môdern Studio™ AI+ membership. Nothing was changed.';
    }
    if (status === 'not_authenticated') {
      return 'Please sign in again to change your Projects. Nothing was changed.';
    }
    return null;
  }

  // Resolves to the server's current copy of a conflicted Project:
  // { current } | { deleted: true } | { unknown: true }.
  function conflictCurrentProject(result, projectId) {
    var current = result && result.data && result.data.current;
    if (current) {
      window.MSGProjects.refreshCloudProject(current);
      return Promise.resolve({ current: current });
    }
    return recoveryApi().readProjectForCheck(projectId).then(function (check) {
      if (check.checked && check.current) return { current: check.current };
      if (check.checked && check.deleted) return { deleted: true };
      return { unknown: true };
    });
  }

  // ---- Home assignment ----
  function assignHomeWithRecovery(reference, targetHomeId) {
    var recovery = recoveryApi();
    var name = '“' + reference.name + '”';

    function attempt(version, retriesLeft) {
      return window.MSGCloudProjects.assignProjectHome(reference.id, version, targetHomeId)
        .then(function (result) {
          if (result && result.ok === true && result.data) {
            window.MSGProjects.upsertCloudProject(result.data);
            return { render: true, message: null };
          }
          var status = result && result.status;

          if (status === 'conflict') {
            return conflictCurrentProject(result, reference.id).then(function (resolved) {
              if (resolved.deleted) {
                return { render: true, message: 'That Project was deleted from another tab or device.' };
              }
              if (resolved.unknown) {
                return { render: true, message: "This Project was changed somewhere else and we couldn't check its latest version. Nothing was changed. Please refresh the page before trying again." };
              }
              var current = resolved.current;
              var kind = recovery.classifyAssignConflict(reference, current, targetHomeId);
              if (kind === 'already_in_target') {
                return {
                  render: true,
                  message: targetHomeId
                    ? name + ' is already in ' + homeLabel(targetHomeId) + '. It was changed from another tab or device.'
                    : name + ' is already not in a Home. It was changed from another tab or device.'
                };
              }
              if (kind === 'field_unchanged' && retriesLeft > 0) {
                return attempt(current.version, retriesLeft - 1);
              }
              if (kind === 'field_unchanged') {
                return { render: true, message: 'This Project is being changed somewhere else, so nothing was changed. Try again in a moment.' };
              }
              return {
                render: true,
                message: current.homeId
                  ? name + ' was moved to ' + homeLabel(current.homeId) + ' from another tab or device, so we didn’t change it. Choose a Home again if you still want to move it.'
                  : name + ' was removed from its Home from another tab or device, so we didn’t change it. Choose a Home again if you still want to move it.'
              };
            });
          }

          if (status === 'cloud_unavailable') {
            return recovery.refreshSnapshotFromCloud().then(function (refresh) {
              if (!refresh.ok) {
                return { render: true, message: "We couldn't reach your account right now. Nothing was changed." };
              }
              if (!findProject(reference.id)) {
                return { render: true, message: 'That Project was deleted from another tab or device.' };
              }
              if (targetHomeId && !findHome(targetHomeId)) {
                return { render: true, message: 'That Home was deleted from another tab or device, so ' + name + ' wasn’t moved.' };
              }
              return { render: true, message: "We couldn't update this Project right now. Nothing was changed." };
            });
          }

          if (result && result.outcomeUnknown) {
            return recovery.refreshSnapshotFromCloud().then(function (refresh) {
              return {
                render: true,
                message: refresh.ok
                  ? 'We couldn’t confirm whether ' + name + ' was moved. We’ve refreshed your Projects so you can see where it is now.'
                  : 'We couldn’t confirm whether ' + name + ' was moved, and we couldn’t refresh your Projects. Please refresh the page before trying again.'
              };
            });
          }

          return {
            render: true,
            message: accountFailureMessage(status) || "We couldn't update this Project. Please try again in a moment."
          };
        });
    }

    return attempt(reference.version, 1);
  }

  // ---- Project delete (never resent) ----
  function deleteProjectWithRecovery(reference) {
    var recovery = recoveryApi();
    var name = '“' + reference.name + '”';

    return window.MSGCloudProjects.deleteProject(reference.id, reference.version)
      .then(function (result) {
        if (result && result.ok === true) {
          if (window.MSGProjects.removeCloudProject(reference.id) !== true) {
            return { render: false, message: 'Your Project was deleted, but we couldn’t update this page. Please refresh the page.' };
          }
          return { render: true, message: null };
        }
        var status = result && result.status;

        if (status === 'conflict') {
          return conflictCurrentProject(result, reference.id).then(function (resolved) {
            if (resolved.deleted) {
              return { render: true, message: 'That Project had already been deleted from another tab or device.' };
            }
            if (resolved.unknown) {
              return { render: true, message: "Nothing was deleted. This Project was changed somewhere else and we couldn't check its latest version. Please refresh the page before deleting it." };
            }
            var changes = recovery.describeProjectChanges(reference, resolved.current, window.MSGProjects.getHomes());
            return {
              render: true,
              message:
                '“' + resolved.current.name + '” was changed from another tab or device' +
                (changes.length ? ': ' + recovery.joinPhrases(changes) : '') +
                '. Nothing was deleted. Review it, then delete it again if you still want to.'
            };
          });
        }

        if (status === 'cloud_unavailable') {
          return recovery.checkProjectExists(reference.id).then(function (check) {
            if (check.state === 'absent') {
              window.MSGProjects.removeCloudProject(reference.id);
              return { render: true, message: 'That Project had already been deleted from another tab or device.' };
            }
            if (check.state === 'present') {
              window.MSGProjects.refreshCloudProject(check.record);
              return { render: true, message: "We couldn't delete this Project right now. Nothing was deleted." };
            }
            return { render: false, message: "We couldn't reach your account right now. Nothing was deleted." };
          });
        }

        if (result && result.outcomeUnknown) {
          return recovery.refreshSnapshotFromCloud().then(function (refresh) {
            if (!refresh.ok) {
              return { render: false, message: 'We couldn’t confirm whether ' + name + ' was deleted, and we couldn’t refresh your Projects. Please refresh the page before trying again.' };
            }
            return {
              render: true,
              message: findProject(reference.id)
                ? 'We couldn’t confirm whether ' + name + ' was deleted. It’s still in your Projects right now. Delete it again if you still want to.'
                : name + ' is no longer in your Projects.'
            };
          });
        }

        return {
          render: false,
          message: accountFailureMessage(status) || "We couldn't delete this Project. Please try again in a moment."
        };
      });
  }

  // ---- Home delete (never resent) ----
  function deleteHomeWithRecovery(reference) {
    var recovery = recoveryApi();
    var name = '“' + reference.name + '”';

    return window.MSGCloudProjects.deleteHome(reference.id, reference.version)
      .then(function (result) {
        if (result && result.ok === true) {
          // The delete has happened; a failed refresh must not claim otherwise.
          return recovery.refreshSnapshotFromCloud().then(function (refresh) {
            return refresh.ok
              ? { render: true, message: null }
              : { render: false, message: "Your Home was deleted, but we couldn't refresh your Projects. Please refresh the page." };
          });
        }
        var status = result && result.status;

        if (status === 'conflict' || status === 'cloud_unavailable' || (result && result.outcomeUnknown)) {
          // A Home change can also change its Projects, so reload both lists.
          return recovery.refreshSnapshotFromCloud().then(function (refresh) {
            if (!refresh.ok) {
              return {
                render: false,
                message: status === 'conflict'
                  ? "Nothing was deleted. This Home was changed somewhere else and we couldn't refresh your Projects. Please refresh the page before deleting it."
                  : (result && result.outcomeUnknown)
                    ? 'We couldn’t confirm whether ' + name + ' was deleted, and we couldn’t refresh your Projects. Please refresh the page before trying again.'
                    : "We couldn't reach your account right now. Nothing was deleted."
              };
            }
            var current = findHome(reference.id);
            if (status === 'conflict') {
              if (!current) {
                return { render: true, message: 'That Home had already been deleted from another tab or device.' };
              }
              var renamed = current.name !== reference.name ? ': it was renamed to “' + current.name + '”' : '';
              return { render: true, message: name + ' was changed from another tab or device' + renamed + '. Nothing was deleted. Review it, then delete it again if you still want to.' };
            }
            if (status === 'cloud_unavailable') {
              return {
                render: true,
                message: current
                  ? "We couldn't delete this Home right now. Nothing was deleted."
                  : 'That Home had already been deleted from another tab or device.'
              };
            }
            return {
              render: true,
              message: current
                ? 'We couldn’t confirm whether ' + name + ' was deleted. It’s still in your account right now. Delete it again if you still want to.'
                : name + ' is no longer in your Homes.'
            };
          });
        }

        return {
          render: false,
          message: accountFailureMessage(status) || "We couldn't delete this Home. Please try again in a moment."
        };
      });
  }

  // Phase 6B #3: after the account refused a new Home.
  function offerDeviceHome(name) {
    showErrorWithAction(
      'Saving to your account is paused right now, so this Home wasn’t created.',
      'Create it on this device instead',
      function () {
        var dev = deviceApi();
        var home = dev && dev.createHome(name);
        if (!home) {
          showError("We couldn't save this Home. Please try again.");
          return;
        }
        clearError();
        if (newHomeNameInput && (newHomeNameInput.value || '').trim() === name) newHomeNameInput.value = '';
        renderAll();
      }
    );
  }

  // ---- Home create ----
  function createHomeWithRecovery(name) {
    var recovery = recoveryApi();
    var quoted = '“' + name + '”';

    return window.MSGCloudProjects.createHome({ name: name })
      .then(function (result) {
        if (result && result.ok === true && result.data) {
          if (window.MSGProjects.upsertCloudHome(result.data) !== true) {
            return { render: false, message: "Your Home was saved, but we couldn't update this page. Please refresh the page." };
          }
          newHomeNameInput.value = '';
          return { render: true, message: null };
        }
        var status = result && result.status;

        // Phase 6B #3: the account refused a new Home (404) or this page
        // already knows account saving is paused. Nothing was created; the
        // page switches to device saving and OFFERS a device copy -- it is
        // only made if the customer taps the button.
        if (status === 'cloud_unavailable' || status === 'writes_paused') {
          if (window.MSGProjects && typeof window.MSGProjects.setAccountWrites === 'function') {
            window.MSGProjects.setAccountWrites('off');
          }
          return { render: true, message: null, pausedCreate: name };
        }

        if (result && result.outcomeUnknown) {
          return recovery.refreshSnapshotFromCloud().then(function (refresh) {
            return {
              render: refresh.ok,
              message: refresh.ok
                ? 'We couldn’t confirm whether ' + quoted + ' was created. We’ve refreshed your Homes — check the list before creating it again so you don’t make a duplicate.'
                : 'We couldn’t confirm whether ' + quoted + ' was created, and we couldn’t refresh your Homes. Please refresh the page before creating it again.'
            };
          });
        }

        return {
          render: false,
          message: accountFailureMessage(status) || "We couldn't save this Home. Please try again in a moment."
        };
      });
  }

  // ============================================================
  // Phase 6C: Home rename
  // ============================================================
  //
  // Rules (approved 6C design):
  //   - Account Homes: Rename only while account saving is confirmed on.
  //     Browser Homes: always, in the phone-only and the mixed view, except
  //     while the move review or a move is open.
  //   - The page checks exactly what the backend checks on the trimmed
  //     name (not empty, at most 200 characters). No other rule: duplicate
  //     names stay allowed, spaces inside the name are kept as typed.
  //   - The title keeps the old name until a rename is confirmed. Messages
  //     describe the Home's confirmed current state, never which tab or
  //     device changed it.
  //   - What the customer typed lives in page memory only (never storage)
  //     and survives every re-render until Save succeeds, Cancel, Dismiss
  //     or leaving the page.
  //   - Account requests go through MSGCloudProjects.recovery (one retry
  //     rule, time limits, reads after unknown outcomes). When a recovery
  //     read fails or times out, Save waits and "Check again" (reads only)
  //     is offered.
  var MAX_HOME_NAME = 200;
  var PAUSED_RENAME_MSG = 'Saving to your account is paused, so this Home wasn’t renamed. What you typed stays here until you leave this page.';
  var MOVE_OPEN_RENAME_MSG = 'Finish or close the move first. What you typed stays here.';
  var MIGRATION_IDLE_STATES = { OFFER: 1, DEFERRED: 1, QUIET_NONE: 1, QUIET_INFO: 1, IDLE: 1 };

  var homeDrafts = {};        // key -> draft (page memory only)
  var homeNotes = {};         // key -> confirmation shown under a Home's title
  var renamePostRender = null; // { key, focus: 'input' | 'open', select, announce }
  var renameLiveEl = null;
  var lastMigrationCloud = null;

  function renameKey(kind, id) { return kind + ':' + id; }

  function renameDomId(key) { return 'mp-rn-' + String(key).replace(/[^A-Za-z0-9_-]/g, '_'); }

  function attrEscape(value) {
    return String(value === undefined || value === null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function quotedName(name) { return '“' + name + '”'; }

  // Values placed inside querySelector attribute selectors.
  function selValue(value) {
    var v = String(value);
    return window.CSS && typeof window.CSS.escape === 'function'
      ? window.CSS.escape(v)
      : v.replace(/["\\]/g, '\\$&');
  }

  function ensureRenameLive() {
    if (renameLiveEl) return renameLiveEl;
    renameLiveEl = document.createElement('p');
    renameLiveEl.className = 'mp-visually-hidden';
    renameLiveEl.setAttribute('role', 'status');
    renameLiveEl.setAttribute('aria-live', 'polite');
    renameLiveEl.setAttribute('data-mp-rename-live', '');
    root.appendChild(renameLiveEl);
    return renameLiveEl;
  }

  function announce(text) {
    if (!text) return;
    var el = ensureRenameLive();
    el.textContent = '';
    setTimeout(function () { el.textContent = text; }, 60);
  }

  // The move review works from a snapshot of browser data taken when it
  // opens, so browser Homes can't be renamed while it (or a move) is open.
  function migrationOpen() {
    if (!migrationMounted || !migrationController || typeof migrationController.getState !== 'function') return false;
    return !MIGRATION_IDLE_STATES[migrationController.getState()];
  }

  // After a browser Home is renamed, the move offer is rebuilt from the
  // browser data so a later review sends the new name.
  function rescanMigration() {
    if (!migrationMounted || !migrationController || migrationOpen()) return;
    var cloud = cloudSnapshotActive()
      ? { projects: window.MSGProjects.getProjects(), homes: window.MSGProjects.getHomes() }
      : lastMigrationCloud;
    if (!cloud) return;
    migrationMounted = migrationController.scan(cloud.projects, cloud.homes) !== 'QUIET_NONE';
  }

  function findRenameHome(kind, id) {
    var list;
    if (kind === 'account') {
      list = cloudSnapshotActive() ? window.MSGProjects.getHomes() : [];
    } else {
      list = cloudSnapshotActive()
        ? (deviceApi() ? deviceApi().getHomes() : [])
        : window.MSGProjects.getHomes();
    }
    return list.filter(function (h) { return h && h.id === id; })[0] || null;
  }

  function saveBlocked(draft) {
    return !!draft.busy ||
      !!draft.check ||
      (draft.kind === 'account' && accountWrites() !== 'on') ||
      (draft.kind === 'device' && migrationOpen());
  }

  function renameMessage(draft) {
    if (draft.busy === 'save') return 'Saving…';
    if (draft.busy === 'check') return 'Checking this Home…';
    if (draft.kind === 'account' && accountWrites() !== 'on') return PAUSED_RENAME_MSG;
    if (draft.kind === 'device' && migrationOpen()) return MOVE_OPEN_RENAME_MSG;
    return draft.message || '';
  }

  function renameEditorHtml(draft, key) {
    var id = renameDomId(key);
    var msg = renameMessage(draft);
    return '<div class="mp-home-rename" data-mp-home-rename="' + attrEscape(key) + '"' +
      (draft.busy ? ' aria-busy="true"' : '') + '>' +
      '<label class="mp-home-rename__label" for="' + id + '-input">Home name</label>' +
      '<input type="text" id="' + id + '-input" class="mp-home-rename__input" data-mp-home-rename-input="' + attrEscape(key) + '"' +
      ' autocomplete="off" autocapitalize="words" enterkeyhint="done" spellcheck="true"' +
      ' aria-describedby="' + id + '-msg"' +
      (draft.invalid ? ' aria-invalid="true"' : '') +
      (draft.busy ? ' readonly' : '') + '>' +
      '<p class="mp-home-rename__msg' + (draft.invalid ? ' is-error' : '') + '" id="' + id + '-msg" data-mp-home-rename-msg="' + attrEscape(key) + '">' +
      escapeHtml(msg) + '</p>' +
      '<div class="mp-home-rename__actions">' +
      '<button type="button" class="button button--primary mp-home-rename__save" data-mp-home-rename-save="' + attrEscape(key) + '"' +
      (saveBlocked(draft) || cloudWriteBusy ? ' disabled' : '') + '>' + (draft.busy === 'save' ? 'Saving…' : 'Save') + '</button>' +
      (draft.check
        ? '<button type="button" class="button button--secondary mp-home-rename__check" data-mp-home-rename-check="' + attrEscape(key) + '"' +
          (draft.busy || cloudWriteBusy ? ' disabled' : '') + '>' + (draft.busy === 'check' ? 'Checking…' : 'Check again') + '</button>'
        : '') +
      '<button type="button" class="button button--secondary mp-home-rename__cancel" data-mp-home-rename-cancel="' + attrEscape(key) + '"' +
      (draft.busy ? ' disabled' : '') + '>Cancel</button>' +
      '</div>' +
      '</div>';
  }

  function renameOpenHtml(home, kind) {
    var key = renameKey(kind, home.id);
    var hintId = renameDomId(key) + '-hint';
    return '<button type="button" class="mp-home-section__rename" data-mp-home-rename-open="' + attrEscape(home.id) + '"' +
      ' data-mp-kind="' + kind + '"' +
      ' aria-label="' + attrEscape('Rename Home ' + quotedName(home.name)) + '"' +
      (kind === 'device' ? ' aria-describedby="' + hintId + '"' : '') + '>Rename</button>';
  }

  function renameHintHtml(home, kind) {
    if (kind !== 'device') return '';
    var key = renameKey(kind, home.id);
    return '<p class="mp-home-section__hint" id="' + renameDomId(key) + '-hint" data-mp-rename-hint="' + attrEscape(key) + '" hidden>' +
      'Finish or close the move first to rename this Home.</p>';
  }

  // The confirmation stays only while the Home still has the name it confirms.
  function homeNoteHtml(key, home) {
    var note = homeNotes[key];
    if (note && note.name !== home.name) {
      delete homeNotes[key];
      note = null;
    }
    return note
      ? '<p class="mp-home-section__status" data-mp-home-note="' + attrEscape(key) + '">' + escapeHtml(note.text) + '</p>'
      : '';
  }

  // A Home that is no longer there keeps the customer's text visible.
  function renameGoneHtml(kind) {
    return Object.keys(homeDrafts).filter(function (key) {
      var d = homeDrafts[key];
      return d && d.gone && d.kind === kind;
    }).map(function (key) {
      var d = homeDrafts[key];
      var where = kind === 'account' ? 'in your account' : 'on this device';
      return '<div class="mp-home-notice" data-mp-home-gone="' + attrEscape(key) + '">' +
        '<p class="mp-home-notice__text">' + escapeHtml(quotedName(d.reference.name) + ' is no longer ' + where + ', so it couldn’t be renamed.') + '</p>' +
        '<p class="mp-home-notice__text">The name you typed: <span class="mp-home-notice__name">' + escapeHtml(d.text) + '</span></p>' +
        '<button type="button" class="mp-error-action" data-mp-home-gone-dismiss="' + attrEscape(key) + '">Dismiss</button>' +
        '</div>';
    }).join('');
  }

  // Drafts whose Home disappeared (deleted, or removed by a list refresh)
  // turn into a notice instead of vanishing with the customer's text.
  function settleMissingDrafts(accountHomes, deviceHomes) {
    Object.keys(homeDrafts).forEach(function (key) {
      var d = homeDrafts[key];
      if (!d || d.gone || d.busy) return;
      var list = d.kind === 'account' ? accountHomes : deviceHomes;
      if (!list) return;
      var present = list.some(function (h) { return h && h.id === d.id; });
      if (!present) d.gone = true;
    });
  }

  // Re-applies what the customer typed after a re-render, and keeps the
  // rename controls' enabled state in step with the page (another change
  // running, account saving, the move review).
  function refreshRenameAvailability() {
    var moveOpen = migrationOpen();
    Array.prototype.forEach.call(root.querySelectorAll('[data-mp-home-rename-open]'), function (btn) {
      var isDevice = btn.getAttribute('data-mp-kind') === 'device';
      btn.disabled = cloudWriteBusy || (isDevice && moveOpen);
      if (isDevice) {
        var hint = root.querySelector('[data-mp-rename-hint="' + selValue(renameKey('device', btn.getAttribute('data-mp-home-rename-open'))) + '"]');
        if (hint) hint.hidden = !moveOpen;
      }
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-mp-home-rename-save]'), function (btn) {
      var d = homeDrafts[btn.getAttribute('data-mp-home-rename-save')];
      btn.disabled = !d || cloudWriteBusy || saveBlocked(d);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-mp-home-rename-check]'), function (btn) {
      var d = homeDrafts[btn.getAttribute('data-mp-home-rename-check')];
      btn.disabled = !d || cloudWriteBusy || !!d.busy;
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-mp-home-rename-msg]'), function (el) {
      var d = homeDrafts[el.getAttribute('data-mp-home-rename-msg')];
      if (!d) return;
      var text = renameMessage(d);
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function focusRenameTarget(post) {
    var el = null;
    var d = homeDrafts[post.key];
    var sep = post.key.indexOf(':');
    var kind = post.key.slice(0, sep);
    if (post.focus === 'input' && d) {
      el = root.querySelector('[data-mp-home-rename-input="' + selValue(post.key) + '"]');
    } else if (post.focus === 'gone') {
      el = root.querySelector('[data-mp-home-gone-dismiss="' + selValue(post.key) + '"]');
    } else if (post.focus === 'set') {
      // After Dismiss: the first Rename of the same set, else the create field.
      el = root.querySelector('[data-mp-home-rename-open][data-mp-kind="' + selValue(kind) + '"]:not(:disabled)') || newHomeNameInput;
    } else {
      el = root.querySelector('[data-mp-home-rename-open="' + selValue(post.key.slice(sep + 1)) + '"][data-mp-kind="' + selValue(kind) + '"]');
    }
    if (el && typeof el.focus === 'function' && !el.disabled) {
      el.focus();
      if (post.select && typeof el.select === 'function') el.select();
    }
  }

  // Called at the end of every renderAll().
  function afterRenderRename(focused) {
    Array.prototype.forEach.call(root.querySelectorAll('[data-mp-home-rename-input]'), function (input) {
      var d = homeDrafts[input.getAttribute('data-mp-home-rename-input')];
      if (d) input.value = d.text;
    });
    refreshRenameAvailability();

    var post = renamePostRender;
    renamePostRender = null;
    if (post) {
      focusRenameTarget(post);
      announce(post.announce);
      return;
    }
    // Keep typing where it was when something else re-rendered the list.
    if (focused) {
      var input = root.querySelector('[data-mp-home-rename-input="' + selValue(focused.key) + '"]');
      if (input) {
        input.focus();
        try { input.setSelectionRange(focused.start, focused.end); } catch (e) { /* ignore */ }
      }
    }
  }

  function focusedRenameInput() {
    var el = document.activeElement;
    if (!el || !root.contains(el) || !el.getAttribute) return null;
    var key = el.getAttribute('data-mp-home-rename-input');
    if (!key) return null;
    return { key: key, start: el.selectionStart, end: el.selectionEnd };
  }

  function openRename(kind, id) {
    var home = findRenameHome(kind, id);
    if (!home) return;
    if (kind === 'account' && accountWrites() !== 'on') return;
    if (kind === 'device' && migrationOpen()) return;
    var key = renameKey(kind, id);
    homeDrafts[key] = {
      kind: kind,
      id: id,
      text: home.name,
      startName: home.name,
      reference: { id: id, name: home.name, version: home.version },
      message: '',
      invalid: false,
      busy: false,
      check: null,
      gone: false
    };
    delete homeNotes[key];
    renamePostRender = { key: key, focus: 'input', select: true };
    renderAll();
  }

  function closeRename(key, post) {
    delete homeDrafts[key];
    renamePostRender = post || { key: key, focus: 'open' };
    renderAll();
  }

  function changedMessage(currentName, requested) {
    return 'This Home’s name changed to ' + quotedName(currentName) + ' since you started editing. Save to use ' +
      quotedName(requested) + ', or Cancel to keep ' + quotedName(currentName) + '.';
  }

  function refusedMessage(reason) {
    if (reason === 'not_authenticated') return 'Please sign in again to rename this Home. This Home wasn’t renamed.';
    if (reason === 'not_entitled') return 'Renaming Homes requires an active Môdern Studio™ AI+ membership. This Home wasn’t renamed.';
    if (reason === 'rate_limited') return 'Please wait a moment, then try again. This Home wasn’t renamed.';
    if (reason === 'invalid') return 'This name wasn’t accepted. This Home wasn’t renamed.';
    return 'This Home wasn’t renamed. Please try again.';
  }

  // Applies one outcome from MSGCloudProjects.recovery to the draft.
  function applyRenameOutcome(key, requested, outcome) {
    var d = homeDrafts[key];
    if (!d) return;
    d.busy = false;
    var o = outcome || { type: 'check', check: 'home', definite: false, sent: { name: d.reference.name, version: d.reference.version } };
    var before = d.reference.name;
    var msg = '';

    if (o.type === 'renamed') {
      var confirmed = 'This Home is now named ' + quotedName(o.home.name) + '.';
      d.check = null;
      if ((d.text || '').trim() === o.home.name) {
        delete homeDrafts[key];
        homeNotes[key] = { name: o.home.name, text: confirmed };
        renamePostRender = { key: key, focus: 'open', announce: confirmed };
        return;
      }
      // The customer typed something else since: keep it, from the new state.
      d.reference = { id: d.id, name: o.home.name, version: o.home.version };
      msg = confirmed;
    } else if (o.type === 'current' || o.type === 'not_renamed') {
      d.check = null;
      d.reference = { id: d.id, name: o.home.name, version: o.home.version };
      if (o.home.name === before) msg = o.type === 'not_renamed' ? 'This Home wasn’t renamed. Please try again.' : 'This Home is currently named ' + quotedName(o.home.name) + '.';
      else msg = changedMessage(o.home.name, requested);
    } else if (o.type === 'paused') {
      d.check = null;
      msg = PAUSED_RENAME_MSG;
    } else if (o.type === 'gone') {
      d.check = null;
      d.gone = true;
      renamePostRender = { key: key, focus: 'gone', announce: quotedName(d.reference.name) + ' is no longer in your account, so it couldn’t be renamed.' };
      return;
    } else if (o.type === 'check') {
      d.check = { kind: o.check, definite: !!o.definite, sent: o.sent, requested: requested };
      msg = o.check === 'lists'
        ? (o.definite ? 'We couldn’t reach your account. This Home wasn’t renamed.' : 'We couldn’t reach your account to check this Home’s current name.')
        : o.definite
          ? 'We couldn’t check this Home’s current name. It wasn’t renamed.'
          : 'We couldn’t confirm this Home’s current name.';
    } else {
      msg = refusedMessage(o.reason);
    }

    d.message = msg;
    d.invalid = false;
    renamePostRender = { key: key, focus: 'input', announce: msg };
  }

  function saveRename(key) {
    var d = homeDrafts[key];
    if (!d || d.busy || d.check || d.gone) return;
    var name = (d.text || '').trim();

    if (!name || name.length > MAX_HOME_NAME) {
      d.invalid = true;
      d.message = !name
        ? 'Enter a name for this Home.'
        : 'Home names can be up to ' + MAX_HOME_NAME + ' characters (this one is ' + name.length + ').';
      renamePostRender = { key: key, focus: 'input', announce: d.message };
      renderAll();
      return;
    }

    if (name === d.reference.name) {
      if (d.reference.name !== d.startName) {
        // The Home already has this name now (it changed while editing):
        // say so rather than closing silently.
        var already = 'This Home is now named ' + quotedName(name) + (d.kind === 'device' ? ' on this device.' : '.');
        delete homeDrafts[key];
        homeNotes[key] = { name: name, text: already };
        renamePostRender = { key: key, focus: 'open', announce: already };
        renderAll();
        return;
      }
      closeRename(key);
      return;
    }

    if (d.kind === 'device') {
      if (migrationOpen()) {
        renamePostRender = { key: key, focus: 'input', announce: MOVE_OPEN_RENAME_MSG };
        renderAll();
        return;
      }
      var dev = deviceApi();
      var res = dev && typeof dev.renameHome === 'function' ? dev.renameHome(d.id, name, d.reference.name) : null;
      if (res && res.status === 'renamed') {
        var note = 'This Home is now named ' + quotedName(res.home.name) + ' on this device.';
        delete homeDrafts[key];
        homeNotes[key] = { name: res.home.name, text: note };
        rescanMigration();
        renamePostRender = { key: key, focus: 'open', announce: note };
        renderAll();
        return;
      }
      if (res && res.status === 'changed') {
        d.reference = { id: d.id, name: res.name, version: d.reference.version };
        d.message = 'This Home’s name on this device changed to ' + quotedName(res.name) + ' since you started editing. Save to use ' +
          quotedName(name) + ', or Cancel to keep ' + quotedName(res.name) + '.';
      } else if (res && res.status === 'missing') {
        d.gone = true;
        renamePostRender = { key: key, focus: 'gone', announce: quotedName(d.reference.name) + ' is no longer on this device, so it couldn’t be renamed.' };
        renderAll();
        return;
      } else {
        d.message = 'We couldn’t save the new name on this device. This Home wasn’t renamed.';
      }
      d.invalid = false;
      renamePostRender = { key: key, focus: 'input', announce: d.message };
      renderAll();
      return;
    }

    // Account Home.
    if (accountWrites() !== 'on') {
      renamePostRender = { key: key, focus: 'input', announce: PAUSED_RENAME_MSG };
      renderAll();
      return;
    }
    if (cloudWriteBusy) return;
    var recovery = recoveryApi();
    if (!recovery || typeof recovery.renameHomeWithRecovery !== 'function') {
      d.message = 'We couldn’t rename this Home right now. Please refresh the page.';
      renamePostRender = { key: key, focus: 'input', announce: d.message };
      renderAll();
      return;
    }

    var reference = { id: d.reference.id, name: d.reference.name, version: d.reference.version };
    d.busy = 'save';
    d.message = '';
    d.invalid = false;
    var started = false;
    runCloudWrite(function () {
      return Promise.resolve().then(function () {
        renderAll();
        started = true;
        return recovery.renameHomeWithRecovery(reference, name);
      }).then(function (outcome) {
        applyRenameOutcome(key, name, outcome);
        return { render: true, message: null };
      }, function () {
        if (!started) {
          // Nothing was sent.
          applyRenameOutcome(key, name, { type: 'refused', reason: 'error' });
        } else {
          applyRenameOutcome(key, name, { type: 'check', check: 'home', definite: false, sent: { name: reference.name, version: reference.version } });
        }
        return { render: true, message: null };
      });
    });
  }

  function checkRename(key) {
    var d = homeDrafts[key];
    if (!d || !d.check || d.busy || cloudWriteBusy) return;
    var recovery = recoveryApi();
    if (!recovery || typeof recovery.checkHomeRename !== 'function') return;
    var check = d.check;
    d.busy = 'check';
    runCloudWrite(function () {
      return Promise.resolve().then(function () {
        renderAll();
        return recovery.checkHomeRename(d.id, check.requested, check.sent, check.kind, check.definite);
      }).then(function (outcome) {
        applyRenameOutcome(key, check.requested, outcome);
        return { render: true, message: null };
      }, function () {
        applyRenameOutcome(key, check.requested, { type: 'check', check: check.kind, definite: check.definite, sent: check.sent });
        return { render: true, message: null };
      });
    });
  }

  function renameUnsettled() {
    return Object.keys(homeDrafts).some(function (key) {
      var d = homeDrafts[key];
      return d && d.kind === 'account' && (d.busy === 'save' || (d.check && !d.check.definite));
    });
  }

  function bindRenameEvents() {
    ensureRenameLive();

    root.addEventListener('click', function (event) {
      var t = event.target && event.target.closest ? event.target.closest('button') : null;
      if (!t || !root.contains(t) || t.disabled) return;
      if (t.hasAttribute('data-mp-home-rename-open')) {
        openRename(t.getAttribute('data-mp-kind'), t.getAttribute('data-mp-home-rename-open'));
      } else if (t.hasAttribute('data-mp-home-rename-save')) {
        saveRename(t.getAttribute('data-mp-home-rename-save'));
      } else if (t.hasAttribute('data-mp-home-rename-cancel')) {
        var key = t.getAttribute('data-mp-home-rename-cancel');
        if (homeDrafts[key] && !homeDrafts[key].busy) closeRename(key);
      } else if (t.hasAttribute('data-mp-home-rename-check')) {
        checkRename(t.getAttribute('data-mp-home-rename-check'));
      } else if (t.hasAttribute('data-mp-home-gone-dismiss')) {
        var goneKey = t.getAttribute('data-mp-home-gone-dismiss');
        delete homeDrafts[goneKey];
        renamePostRender = { key: goneKey, focus: 'set' };
        renderAll();
      }
    });

    root.addEventListener('input', function (event) {
      var el = event.target;
      var key = el && el.getAttribute ? el.getAttribute('data-mp-home-rename-input') : null;
      var d = key ? homeDrafts[key] : null;
      if (!d || d.busy) return;
      d.text = el.value;
      if (d.invalid) {
        d.invalid = false;
        d.message = '';
        el.removeAttribute('aria-invalid');
        var msgEl = root.querySelector('[data-mp-home-rename-msg="' + selValue(key) + '"]');
        if (msgEl) {
          msgEl.classList.remove('is-error');
          msgEl.textContent = renameMessage(d);
        }
      }
    });

    root.addEventListener('keydown', function (event) {
      var el = event.target;
      var key = el && el.getAttribute ? el.getAttribute('data-mp-home-rename-input') : null;
      if (!key || !homeDrafts[key]) return;
      // Enter that confirms an input-method choice (e.g. Japanese, Chinese) isn't Save.
      if (event.isComposing || event.keyCode === 229) return;
      if (event.key === 'Enter') {
        event.preventDefault();
        var save = root.querySelector('[data-mp-home-rename-save="' + selValue(key) + '"]');
        if (save && !save.disabled) saveRename(key);
      } else if (event.key === 'Escape') {
        event.preventDefault();
        if (!homeDrafts[key].busy) closeRename(key);
      }
    });

    // The move panel changes state without re-rendering the Homes list.
    if (migrationContainer && typeof MutationObserver === 'function') {
      new MutationObserver(function () { refreshRenameAvailability(); })
        .observe(migrationContainer, { childList: true, subtree: true });
    }

    // Account saving switched off during this visit (a refused create).
    window.addEventListener('msg:account-writes-paused', function () {
      if (Object.keys(homeDrafts).length) renderAll();
    });

    window.addEventListener('beforeunload', function (event) {
      if (!renameUnsettled()) return;
      event.preventDefault();
      event.returnValue = '';
    });
  }

  // Phase 5D copy cleanup: reflects the page's actual current storage mode
  // rather than a static claim. Never mentions migration/rollout -- that
  // scenario is already covered separately by the legacy-import prompt,
  // which is gated on its own (hasLegacyData()/hasSeenLegacyPrompt()) and
  // is left untouched here.
  function updateStorageDisclosure() {
    if (!storageDisclosureEl) return;

    if (cloudSnapshotActive()) {
      storageDisclosureEl.textContent = accountWrites() === 'on'
        ? 'Your Projects are saved to your Môdern Studio™ account.'
        : 'Your account Projects are below. Saving to your account is paused, so new work is saved on this device for now.';
    } else if (pageView.readFailed) {
      storageDisclosureEl.textContent = 'We couldn’t reach your account just now, so you’re seeing Projects saved on this device. Anything in your account is safe.';
    } else {
      storageDisclosureEl.textContent = 'Your Projects are saved on this device.';
    }
  }

  var STYLE_LABELS = {
    modern: 'Modern',
    japandi: 'Japandi',
    'organic-modern': 'Organic Modern',
    scandinavian: 'Scandinavian',
    industrial: 'Industrial',
    'mid-century': 'Mid-Century',
    minimalist: 'Minimalist',
    coastal: 'Coastal',
    farmhouse: 'Farmhouse',
    traditional: 'Traditional',
    luxury: 'Luxury',
    bohemian: 'Bohemian'
  };

  // Phase 6B #3: links to a browser record say so (saved=device), so the tool
  // opens this customer's browser copy even while it shows the account.
  // Empty panels also carry the Project, so the tool opens it: an account
  // Project becomes the "Add to Project" target (writes on) or is offered as
  // a device copy (writes off); a browser Project is updated on this device.
  function deviceLinkParams(project, src) {
    if (src === 'device') return '&project=' + encodeURIComponent(project.id) + '&saved=device';
    if (src === 'account') return '&project=' + encodeURIComponent(project.id);
    return '';
  }

  function moodBoardPanelHtml(project, src) {
    var mb = project.moodBoard;

    if (!mb) {
      return '<div class="mp-panel mp-panel--empty">' +
        '<p class="mp-panel__label">Mood Board</p>' +
        '<p class="mp-panel__empty-text">Not added yet</p>' +
        '<a href="/pages/mood-board?room=' +
        encodeURIComponent(project.room) +
        deviceLinkParams(project, src) +
        '" class="mp-panel__cta">Create one →</a>' +
        '</div>';
    }

    var chips = (mb.colors || [])
      .slice(0, 5)
      .map(function (hex) {
        return '<span class="mp-color-chip" style="background:' +
          hex +
          '"></span>';
      })
      .join('');

    var openUrl =
      '/pages/mood-board?project=' +
      encodeURIComponent(project.id) +
      '&room=' +
      encodeURIComponent(project.room) +
      (mb.style
        ? '&style=' + encodeURIComponent(mb.style)
        : '') +
      (src === 'device' ? '&saved=device' : '');

    return '<div class="mp-panel">' +
      '<p class="mp-panel__label">Mood Board</p>' +
      '<p class="mp-panel__value">' +
      escapeHtml(STYLE_LABELS[mb.style] || mb.style) +
      '</p>' +
      '<div class="mp-color-row">' + chips + '</div>' +
      '<a href="' +
      openUrl +
      '" class="mp-panel__cta">Continue Mood Board →</a>' +
      '</div>';
  }

  function spacePlanPanelHtml(project, src) {
    var sp = project.spacePlan;

    if (!sp) {
      return '<div class="mp-panel mp-panel--empty">' +
        '<p class="mp-panel__label">Space Plan</p>' +
        '<p class="mp-panel__empty-text">Not added yet</p>' +
        '<a href="/pages/space-planner?room=' +
        encodeURIComponent(project.room) +
        deviceLinkParams(project, src) +
        '" class="mp-panel__cta">Create one →</a>' +
        '</div>';
    }

    return '<div class="mp-panel">' +
      '<p class="mp-panel__label">Space Plan</p>' +
      '<p class="mp-panel__value">' +
      sp.length +
      "' × " +
      sp.width +
      "'" +
      '</p>' +
      '<p class="mp-panel__sub">' +
      (
        sp.ownedItems && sp.ownedItems.length
          ? sp.ownedItems.length +
            ' owned piece' +
            (sp.ownedItems.length > 1 ? 's' : '') +
            ' included'
          : 'Sized for real products'
      ) +
      '</p>' +
      '<a href="/pages/space-planner?project=' +
      encodeURIComponent(project.id) +
      '&room=' +
      encodeURIComponent(project.room) +
      (src === 'device' ? '&saved=device' : '') +
      '" class="mp-panel__cta">Continue Space Plan →</a>' +
      '</div>';
  }

  // Every project card includes a small "Add to a Home" control.
  // During a Phase 5D cloud snapshot this control remains visible, but any
  // mutation attempt is stopped by the read-only guard below.
  function homeControlHtml(project, homes, src, readOnly) {
    var currentHome = src === 'device' && cloudSnapshotActive()
      ? deviceApi().getHomeForProject(project.id)
      : window.MSGProjects.getHomeForProject(project.id);

    var options =
      '<option value="">No home</option>' +
      homes
        .map(function (h) {
          var selected =
            currentHome && currentHome.id === h.id
              ? ' selected'
              : '';

          return '<option value="' +
            h.id +
            '"' +
            selected +
            '>' +
            escapeHtml(h.name) +
            '</option>';
        })
        .join('');

    return '<div class="mp-home-control">' +
      '<label class="mp-home-control__label">Home</label>' +
      '<select class="mp-home-select" data-mp-home-select="' +
      project.id +
      '"' +
      // P2 (release polish): the dropdown's accessible name, e.g.
      // Home for “QA Office” (the visible "Home" label is not linked to it).
      ' aria-label="' + attrEscape('Home for ' + quotedName(project.name || 'this Project')) + '"' +
      srcAttr(src) + (readOnly ? ' disabled' : '') + '>' +
      options +
      '</select>' +
      '</div>';
  }

  function srcAttr(src) {
    return src === 'device' && cloudSnapshotActive() ? ' data-mp-src="device"' : '';
  }

  // src: 'account' (account view record), 'device' (browser record).
  // readOnly: account records while account saving is off or unknown.
  function projectCardHtml(project, homes, src, readOnly) {
    return '<div class="mp-project-card" data-mp-project-card="' +
      project.id +
      '"' + (src === 'device' && cloudSnapshotActive() ? ' data-mp-card-src="device"' : '') + '>' +
      '<div class="mp-project-card__header">' +
      '<div>' +
      '<p class="mp-project-card__name">' +
      escapeHtml(project.name) +
      '</p>' +
      '<p class="mp-project-card__meta">' +
      escapeHtml(project.roomLabel) +
      ' · ' +
      escapeHtml(updatedLabel(project, src)) +
      '</p>' +
      '</div>' +
      (readOnly
        ? ''
        : '<button type="button" class="mp-project-card__delete" data-mp-delete="' +
          project.id +
          '"' + srcAttr(src) + ' aria-label="Delete project">&times;</button>') +
      '</div>' +
      '<div class="mp-project-card__panels">' +
      moodBoardPanelHtml(project, src) +
      spacePlanPanelHtml(project, src) +
      '</div>' +
      homeControlHtml(project, homes, src, readOnly) +
      '</div>';
  }

  function homeSectionHtml(home, projectsInHome, homes, src, readOnly) {
    // Phase 6C: the Home's rename state (account or browser record).
    var kind = src === 'account' ? 'account' : 'device';
    var key = renameKey(kind, home.id);
    var draft = homeDrafts[key] && !homeDrafts[key].gone ? homeDrafts[key] : null;
    var canRename = kind === 'device' || !readOnly;

    return '<div class="mp-home-section" data-mp-home-section="' +
      home.id +
      '"' + (src === 'device' && cloudSnapshotActive() ? ' data-mp-card-src="device"' : '') + '>' +
      '<div class="mp-home-section__header' + (draft ? ' is-editing' : '') + '">' +
      (draft
        ? renameEditorHtml(draft, key)
        : '<p class="mp-home-section__title">🏠 ' +
          escapeHtml(home.name) +
          '</p>' +
          '<div class="mp-home-section__actions">' +
          (canRename ? renameOpenHtml(home, kind) : '') +
          (readOnly
            ? ''
            : '<button type="button" class="mp-home-section__delete" data-mp-home-delete="' +
              home.id +
              '"' + srcAttr(src) + '>Delete Home</button>') +
          '</div>') +
      '</div>' +
      (draft ? '' : renameHintHtml(home, kind) + homeNoteHtml(key, home)) +
      (
        projectsInHome.length
          ? projectsInHome
              .map(function (p) {
                return projectCardHtml(p, homes, src, readOnly);
              })
              .join('')
          : '<p class="mp-home-section__empty">No rooms added to this home yet — use the “Home” dropdown on a project below.</p>'
      ) +
      '</div>';
  }

  function showCloudReadOnlyMessage() {
    showError(
      "Importing previously saved Projects isn't available while your Projects are synced to your account."
    );
  }

  function bindHomeSelects() {
    Array.prototype.forEach.call(
      listEl.parentElement.querySelectorAll('[data-mp-home-select]'),
      function (sel) {
        sel.addEventListener('change', function () {
          var projectId =
            sel.getAttribute('data-mp-home-select');

          // Phase 6B #3: a browser record beside the account view.
          if (sel.getAttribute('data-mp-src') === 'device') {
            var dev = deviceApi();
            var done = dev && (sel.value
              ? !!dev.assignProjectToHome(sel.value, projectId)
              : dev.removeProjectFromHome(projectId));
            if (!done) showError("We couldn't update this Project. Please try again.");
            else clearError();
            renderAll();
            return;
          }

          // Phase 6B #3: account records can't be changed while account
          // saving is off or unknown (the control is disabled; this is the
          // guard behind it).
          if (cloudSnapshotActive() && accountWrites() !== 'on') {
            showError('Changes to Projects in your account are paused for now. Nothing was changed.');
            renderAll();
            return;
          }

          // Phase 5D.5: cloud-active Home assignment. Mirrors the delete
          // handler's shape -- a failure at any step here must leave the
          // Project's Home membership untouched and re-sync the dropdown
          // to what's actually persisted: no local fallback, no
          // optimistic update, no assumption the UI already matches the
          // backend.
          if (cloudSnapshotActive()) {
            if (
              !window.MSGCloudProjects ||
              typeof window.MSGCloudProjects.assignProjectHome !== 'function' ||
              !window.MSGProjects ||
              typeof window.MSGProjects.getProject !== 'function' ||
              typeof window.MSGProjects.upsertCloudProject !== 'function'
            ) {
              showError(
                "We couldn't update this Project. Please try again."
              );
              renderAll();
              return;
            }

            var existingProject =
              window.MSGProjects.getProject(projectId);

            if (!existingProject) {
              showError(
                "We couldn't update this Project. Please try again."
              );
              renderAll();
              return;
            }

            var targetHomeId = sel.value || null;

            // Phase 6A-5: conflict-aware assignment (see above).
            if (!recoveryApi() || typeof window.MSGProjects.refreshCloudProject !== 'function') {
              showError("We couldn't update this Project right now. Please refresh the page.");
              renderAll();
              return;
            }
            runCloudWrite(function () {
              return assignHomeWithRecovery(existingProject, targetHomeId);
            });

            return;
          }

          var ok;

          if (sel.value) {
            ok = !!window.MSGProjects.assignProjectToHome(
              sel.value,
              projectId
            );
          } else {
            ok =
              window.MSGProjects.removeProjectFromHome(
                projectId
              );
          }

          if (!ok) {
            showError(
              "We couldn't update this Project. Please try again."
            );

            // Re-sync the dropdown with what actually persisted.
            renderAll();
            return;
          }

          clearError();
          renderAll();
        });
      }
    );
  }

  // Phase 5D.5: cloud-aware Home membership. A cloud Home carries no
  // projectIds -- membership is derived from each Project's own homeId
  // instead, the inverse of the local model. Never mutates the Home object
  // and never fabricates/persists a projectIds array onto it.
  function projectsForHome(home, allProjects) {
    if (cloudSnapshotActive()) {
      return allProjects.filter(function (p) {
        return p && p.homeId === home.id;
      });
    }

    return (home.projectIds || [])
      .map(function (pid) {
        return window.MSGProjects.getProject(pid);
      })
      .filter(Boolean);
  }

  // Phase 6B #3: one list of Homes + Projects (account view or this device).
  function setHtml(homes, allProjects, src, readOnly) {
    var homedProjectIds = {};

    if (src === 'account') {
      // Only count a Project as homed if its homeId resolves to an actual
      // Home in the current cloud snapshot -- a stale/orphaned homeId (one
      // that no longer matches any Home) must not hide the Project from
      // the ungrouped section, matching getHomeForProject()'s null result
      // for the same case.
      var validHomeIds = {};

      homes.forEach(function (h) {
        if (h && h.id) {
          validHomeIds[h.id] = true;
        }
      });

      allProjects.forEach(function (p) {
        if (p && p.homeId && validHomeIds[p.homeId]) {
          homedProjectIds[p.id] = true;
        }
      });
    } else {
      homes.forEach(function (h) {
        (h.projectIds || []).forEach(function (pid) {
          homedProjectIds[pid] = true;
        });
      });
    }

    var homesHtml = homes
      .map(function (h) {
        var projectsInHome = src === 'account'
          ? allProjects.filter(function (p) { return p && p.homeId === h.id; })
          : (h.projectIds || [])
              .map(function (pid) {
                return allProjects.filter(function (p) { return p.id === pid; })[0];
              })
              .filter(Boolean);

        return homeSectionHtml(h, projectsInHome, homes, src, readOnly);
      })
      .join('');

    var ungrouped =
      allProjects.filter(function (p) {
        return !homedProjectIds[p.id];
      });

    var projectsHtml =
      ungrouped.length
        ? (
            homes.length
              ? '<p class="mp-board-section-label">Other Projects</p>'
              : ''
          ) +
          ungrouped
            .map(function (p) {
              return projectCardHtml(p, homes, src, readOnly);
            })
            .join('')
        : '';

    return { homes: homesHtml, projects: projectsHtml };
  }

  // Phase 6B #3: the create row says where a new Home is saved whenever that
  // isn't obvious (account view with writes off, or both sets on the page).
  var createDestEl = null;

  function updateCreateControl(showDeviceSet) {
    if (!newHomeCreateBtn) return;
    var dest = createDestination();
    var label = '+ Create a Home';
    var helper = '';

    if (dest === 'device') {
      label = '+ Create a Home on this device';
      helper = 'Saves on this device. You can move it to your account later.';
    } else if (dest === 'account' && showDeviceSet) {
      label = '+ Create a Home in your account';
      helper = 'Saves to your account.';
    }

    newHomeCreateBtn.textContent = label;
    newHomeCreateBtn.setAttribute('data-mp-create-dest', dest);

    if (!createDestEl) {
      createDestEl = document.createElement('p');
      createDestEl.className = 'mp-create-dest';
      createDestEl.setAttribute('data-mp-create-dest-note', '');
      var row = newHomeCreateBtn.parentNode;
      if (row && row.parentNode) row.parentNode.insertBefore(createDestEl, row.nextSibling);
    }
    createDestEl.textContent = helper;
    createDestEl.hidden = !helper;
  }

  // Phase 6B #3: the move can only run while account saving is on.
  function hideMigrationIfPaused() {
    if (migrationMounted && accountWrites() !== 'on' && migrationContainer) {
      migrationContainer.hidden = true;
      migrationContainer.innerHTML = '';
      migrationMounted = false;
    }
  }

  function renderAll() {
    if (!window.MSGProjects) return;

    var focusedRename = focusedRenameInput();
    hideMigrationIfPaused();
    updateStorageDisclosure();

    var accountView = cloudSnapshotActive();
    var readOnly = accountView && accountWrites() !== 'on';

    var allProjects =
      window.MSGProjects.getProjects();

    var homes =
      window.MSGProjects.getHomes();

    // Phase 6B #3: browser-only work stays visible beside the account view.
    var device = accountView && deviceApi() ? deviceApi() : null;
    var deviceProjects = device ? device.getProjects() : [];
    var deviceHomes = device ? device.getHomes() : [];
    var showDeviceSet = !!(deviceProjects.length || deviceHomes.length);

    updateCreateControl(showDeviceSet);

    // Phase 6C: an open rename whose Home is no longer listed keeps the
    // customer's text as a notice.
    settleMissingDrafts(accountView ? homes : null, accountView ? deviceHomes : homes);
    var mainKind = accountView ? 'account' : 'device';
    var mainGone = renameGoneHtml(mainKind);
    var deviceGone = accountView ? renameGoneHtml('device') : '';

    if (!allProjects.length && !homes.length && !showDeviceSet) {
      emptyBlock.hidden = false;
      homesListEl.innerHTML = mainGone + deviceGone;
      listEl.innerHTML = '';
      afterRenderRename(focusedRename);
      return;
    }

    emptyBlock.hidden = allProjects.length > 0 || showDeviceSet;

    var main = setHtml(homes, allProjects, accountView ? 'account' : 'device', readOnly);

    var head = '';
    if (accountView && showDeviceSet) {
      head += '<p class="mp-set-heading" data-mp-set-heading="account">In your account</p>';
    }
    if (readOnly) {
      head += '<p class="mp-set-note" data-mp-paused-note>Changes to Projects in your account are paused for now. You can still open them.</p>';
    }

    homesListEl.innerHTML = head + mainGone + main.homes;

    var deviceHtml = '';
    if (showDeviceSet) {
      var deviceSet = setHtml(deviceHomes, deviceProjects, 'device', false);
      deviceHtml =
        '<div class="mp-device-set" data-mp-device-set>' +
        '<p class="mp-set-heading" data-mp-set-heading="device">On this device</p>' +
        '<p class="mp-set-note">' +
        (accountWrites() === 'on'
          ? 'Saved only in this browser. Use “Review and move” above to move them to your account.'
          : 'Saved only in this browser. You’ll be able to move these to your account when saving to your account is back.') +
        '</p>' +
        deviceGone +
        deviceSet.homes +
        deviceSet.projects +
        '</div>';
    } else if (deviceGone) {
      deviceHtml = '<div class="mp-device-set" data-mp-device-set>' + deviceGone + '</div>';
    }

    listEl.innerHTML = main.projects + deviceHtml;

    bindHomeSelects();

    // Phase 6A-5: re-rendered controls stay disabled while a cloud change runs.
    if (cloudWriteBusy) applyCloudBusy();

    // Phase 6C: restore what was typed, focus and announcements.
    afterRenderRename(focusedRename);

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-mp-delete]'),
      function (btn) {
        btn.addEventListener('click', function () {
          var projectId = btn.getAttribute('data-mp-delete');
          var isDevice = btn.getAttribute('data-mp-src') === 'device';

          if (
            !window.confirm(
              isDevice
                ? 'Delete this project from this device? This cannot be undone.'
                : 'Delete this project? This cannot be undone.'
            )
          ) {
            return;
          }

          // Phase 6B #3: a browser record beside the account view.
          if (isDevice) {
            if (!deviceApi() || !deviceApi().deleteProject(projectId)) {
              showError("We couldn't delete this Project. Please try again.");
              return;
            }
            clearError();
            renderAll();
            return;
          }

          if (cloudSnapshotActive() && accountWrites() !== 'on') {
            showError('Changes to Projects in your account are paused for now. Nothing was deleted.');
            return;
          }

          // Phase 5D.4: cloud-active delete. Deliberately does NOT reuse
          // showCloudReadOnlyMessage()/the read-only block above -- deletion
          // is the one mutation now routed to the cloud backend instead of
          // being blocked. A failure at any step here must leave the
          // Project visible and untouched: no local fallback, no removal
          // from the cloud snapshot, no renderAll() call.
          if (cloudSnapshotActive()) {
            if (
              !window.MSGCloudProjects ||
              typeof window.MSGCloudProjects.deleteProject !== 'function' ||
              !window.MSGProjects ||
              typeof window.MSGProjects.getProject !== 'function' ||
              typeof window.MSGProjects.removeCloudProject !== 'function'
            ) {
              showError(
                "We couldn't delete this Project. Please try again."
              );
              return;
            }

            var existingProject =
              window.MSGProjects.getProject(projectId);

            if (!existingProject) {
              showError(
                "We couldn't delete this Project. Please try again."
              );
              return;
            }

            // Phase 6A-5: conflict-aware delete; never resent automatically.
            if (!recoveryApi() || typeof window.MSGProjects.refreshCloudProject !== 'function') {
              showError("We couldn't delete this Project right now. Please refresh the page.");
              return;
            }
            runCloudWrite(function () {
              return deleteProjectWithRecovery(existingProject);
            });

            return;
          }

          var ok =
            window.MSGProjects.deleteProject(projectId);

          if (!ok) {
            showError(
              "We couldn't delete this Project. Please try again."
            );
            return;
          }

          clearError();
          renderAll();
        });
      }
    );

    Array.prototype.forEach.call(
      root.querySelectorAll('[data-mp-home-delete]'),
      function (btn) {
        btn.addEventListener('click', function () {
          var homeId = btn.getAttribute('data-mp-home-delete');
          var isDeviceHome = btn.getAttribute('data-mp-src') === 'device';

          if (
            !window.confirm(
              'Delete this home? Your projects and their mood boards/space plans will NOT be deleted — they\'ll just no longer be grouped together.'
            )
          ) {
            return;
          }

          // Phase 6B #3: a browser Home beside the account view.
          if (isDeviceHome) {
            if (!deviceApi() || !deviceApi().deleteHome(homeId)) {
              showError("We couldn't delete this Home. Please try again.");
              return;
            }
            clearError();
            renderAll();
            return;
          }

          if (cloudSnapshotActive() && accountWrites() !== 'on') {
            showError('Changes to Homes in your account are paused for now. Nothing was deleted.');
            return;
          }

          // Phase 5D.7: cloud-active Home delete. A successful backend
          // delete atomically clears home_id and bumps the version of
          // every affected Project in Postgres (see homes-repo.js), but
          // the { deleted: true } response does not say which Projects
          // changed or what their new versions are. Rather than guess or
          // locally clear/increment anything, this re-fetches authoritative
          // state from the cloud backend after a confirmed delete and
          // replaces the in-memory snapshot wholesale with it -- the same
          // source of truth the page uses on initial load. A failure at
          // any step here must leave the Home and its assigned Projects
          // visible and untouched: no local fallback, no snapshot mutation,
          // no renderAll() call.
          if (cloudSnapshotActive()) {
            if (
              !window.MSGCloudProjects ||
              typeof window.MSGCloudProjects.deleteHome !== 'function' ||
              typeof window.MSGCloudProjects.listProjects !== 'function' ||
              typeof window.MSGCloudProjects.listHomes !== 'function' ||
              !window.MSGProjects ||
              typeof window.MSGProjects.getHomes !== 'function' ||
              typeof window.MSGProjects.setCloudSnapshot !== 'function'
            ) {
              showError(
                "We couldn't delete this Home. Please try again."
              );
              return;
            }

            var existingHome =
              window.MSGProjects.getHomes().filter(function (h) {
                return h && h.id === homeId;
              })[0];

            if (!existingHome) {
              showError(
                "We couldn't delete this Home. Please try again."
              );
              return;
            }

            // Phase 6A-5: conflict-aware delete; never resent automatically.
            if (!recoveryApi()) {
              showError("We couldn't delete this Home right now. Please refresh the page.");
              return;
            }
            runCloudWrite(function () {
              return deleteHomeWithRecovery(existingHome);
            });

            return;
          }

          var ok =
            window.MSGProjects.deleteHome(homeId);

          if (!ok) {
            showError(
              "We couldn't delete this Home. Please try again."
            );
            return;
          }

          clearError();
          renderAll();
        });
      }
    );
  }

  if (newHomeCreateBtn) {
    newHomeCreateBtn.addEventListener(
      'click',
      function () {
        var name =
          (newHomeNameInput.value || '').trim();

        if (
          !name ||
          !window.MSGProjects
        ) {
          return;
        }

        // Phase 6B #3: account view with account saving off or unknown --
        // the new Home is saved on this device (the button says so).
        if (createDestination() === 'device') {
          var deviceHome = deviceApi() && deviceApi().createHome(name);
          if (!deviceHome) {
            showError("We couldn't save this Home. Please try again.");
            return;
          }
          clearError();
          newHomeNameInput.value = '';
          renderAll();
          return;
        }

        // Phase 5D.6: cloud-active Home creation. Mirrors the delete and
        // Home-assignment handlers' shape -- a failure at any step here
        // must leave the name input and the existing Homes list untouched:
        // no optimistic update, no local fallback while a cloud snapshot
        // is active.
        if (cloudSnapshotActive()) {
          if (
            !window.MSGCloudProjects ||
            typeof window.MSGCloudProjects.createHome !== 'function' ||
            typeof window.MSGProjects.upsertCloudHome !== 'function'
          ) {
            showError(
              "We couldn't save this Home. Please try again."
            );
            return;
          }

          // Phase 6A-5: an unconfirmed create refreshes the list instead of
          // being resent.
          if (!recoveryApi()) {
            showError("We couldn't save this Home right now. Please refresh the page.");
            return;
          }
          runCloudWrite(function () {
            return createHomeWithRecovery(name);
          });

          return;
        }

        var home =
          window.MSGProjects.createHome(name);

        if (!home) {
          showError(
            "We couldn't save this Home. Please try again."
          );
          return;
        }

        clearError();
        newHomeNameInput.value = '';
        renderAll();
      }
    );
  }

  // ---- Legacy data import (Phase 4D.3) ----
  //
  // A cloud-backed view must never offer the local legacy import action.
  // Legacy import remains available only when My Projects has fallen back
  // to its original customer-scoped browser storage.
  function maybeShowLegacyPrompt() {
    if (
      !legacyPrompt ||
      !window.MSGProjects
    ) {
      return;
    }

    if (cloudSnapshotActive() || migrationMounted) {
      legacyPrompt.hidden = true;
      return;
    }

    if (
      window.MSGProjects.hasLegacyData() &&
      !window.MSGProjects.hasSeenLegacyPrompt()
    ) {
      legacyPrompt.hidden = false;
    } else {
      legacyPrompt.hidden = true;
    }
  }

  if (legacyImportBtn) {
    legacyImportBtn.addEventListener(
      'click',
      function () {
        if (!window.MSGProjects) return;

        if (cloudSnapshotActive()) {
          legacyPrompt.hidden = true;
          showCloudReadOnlyMessage();
          return;
        }

        var result =
          window.MSGProjects.importLegacyData();

        if (
          !result ||
          !result.success
        ) {
          showError(
            "We couldn't import your saved Projects. Please try again."
          );
          return;
        }

        clearError();
        legacyPrompt.hidden = true;
        renderAll();
      }
    );
  }

  if (legacyDismissBtn) {
    legacyDismissBtn.addEventListener(
      'click',
      function () {
        if (!window.MSGProjects) return;

        window.MSGProjects.dismissLegacyPrompt();
        legacyPrompt.hidden = true;
      }
    );
  }

  function showLocked(message) {
    lockedText.textContent = message;
    lockedBlock.hidden = false;
    contentBlock.hidden = true;
  }

  function showUnlocked() {
    lockedBlock.hidden = true;
    contentBlock.hidden = false;
    renderAll();
    maybeShowLegacyPrompt();
  }

  /*
   * Phase 5D read-only cloud hydration.
   *
   * Rules:
   *
   * 1. Cloud Projects and Homes must BOTH succeed before a snapshot is
   *    activated.
   *
   * 2. A partial or failed cloud read never replaces the existing local
   *    customer-scoped view.
   *
   * 3. Cloud data is passed only to MSGProjects.setCloudSnapshot().
   *    It is never persisted to localStorage.
   *
   * 4. During this controlled migration, if BOTH cloud collections are
   *    empty but this browser already has customer-scoped local Projects
   *    or Homes, we keep showing the local data. This avoids making a
   *    customer believe their existing work disappeared merely because
   *    their cloud library has not yet been migrated.
   *
   * 5. If both cloud collections are legitimately empty AND there is no
   *    local customer-scoped data, the empty cloud snapshot is valid and
   *    the normal empty state is shown.
   */
  function hydrateCloudReadOnly() {
    if (
      !window.MSGProjects ||
      !window.MSGCloudProjects ||
      typeof window.MSGProjects.setCloudSnapshot !== 'function' ||
      typeof window.MSGCloudProjects.listProjects !== 'function' ||
      typeof window.MSGCloudProjects.listHomes !== 'function'
    ) {
      return Promise.resolve({
        activated: false,
        reason: 'adapter_unavailable'
      });
    }

    pageView.readFailed = false;

    // Make sure this hydration attempt starts from the original local view.
    if (
      typeof window.MSGProjects.clearCloudSnapshot === 'function'
    ) {
      window.MSGProjects.clearCloudSnapshot();
    }

    var localProjects =
      window.MSGProjects.getProjects();

    var localHomes =
      window.MSGProjects.getHomes();

    return Promise.all([
      window.MSGCloudProjects.listProjects(),
      window.MSGCloudProjects.listHomes()
    ])
      .then(function (results) {
        var projectResult = results[0];
        var homeResult = results[1];

        var projectsOk =
          projectResult &&
          projectResult.ok === true &&
          Array.isArray(projectResult.data);

        var homesOk =
          homeResult &&
          homeResult.ok === true &&
          Array.isArray(homeResult.data);

        if (!projectsOk || !homesOk) {
          if (
            typeof window.MSGProjects.clearCloudSnapshot === 'function'
          ) {
            window.MSGProjects.clearCloudSnapshot();
          }

          pageView.readFailed = true;
          pageView.writes = 'unknown';
          if (typeof window.MSGProjects.setAccountWrites === 'function') {
            window.MSGProjects.setAccountWrites('unknown');
          }

          return {
            activated: false,
            reason: 'cloud_read_unavailable',
            projects: projectResult || null,
            homes: homeResult || null
          };
        }

        var cloudProjects =
          projectResult.data;

        var cloudHomes =
          homeResult.data;

        // Phase 6B #3: one view rule for all three pages (see
        // MSGProjects.decideCloudView): account records -> account view;
        // empty account -> account view only when account saving is on and
        // there is no browser-only work. Browser copies already moved (or
        // moved and later deleted) don't count as browser-only work.
        var decision = typeof window.MSGProjects.decideCloudView === 'function'
          ? window.MSGProjects.decideCloudView(projectResult, homeResult)
          : {
              activate: !(cloudProjects.length === 0 && cloudHomes.length === 0 && (localProjects.length > 0 || localHomes.length > 0)),
              writes: 'unknown'
            };

        pageView.writes = decision.writes;
        if (typeof window.MSGProjects.setAccountWrites === 'function') {
          window.MSGProjects.setAccountWrites(decision.writes);
        }

        if (!decision.activate) {
          if (
            typeof window.MSGProjects.clearCloudSnapshot === 'function'
          ) {
            window.MSGProjects.clearCloudSnapshot();
          }

          return {
            activated: false,
            reason: 'empty_cloud_preserved_local',
            writes: decision.writes,
            cloudProjects: cloudProjects,
            cloudHomes: cloudHomes
          };
        }

        var activated =
          window.MSGProjects.setCloudSnapshot(
            cloudProjects,
            cloudHomes,
            { writes: decision.writes }
          );

        if (!activated) {
          if (
            typeof window.MSGProjects.clearCloudSnapshot === 'function'
          ) {
            window.MSGProjects.clearCloudSnapshot();
          }

          return {
            activated: false,
            reason: 'snapshot_rejected'
          };
        }

        return {
          activated: true,
          reason: 'cloud_snapshot_active',
          writes: decision.writes,
          cloudProjects: cloudProjects,
          cloudHomes: cloudHomes
        };
      })
      .catch(function () {
        if (
          window.MSGProjects &&
          typeof window.MSGProjects.clearCloudSnapshot === 'function'
        ) {
          window.MSGProjects.clearCloudSnapshot();
        }

        pageView.readFailed = true;
        pageView.writes = 'unknown';
        if (window.MSGProjects && typeof window.MSGProjects.setAccountWrites === 'function') {
          window.MSGProjects.setAccountWrites('unknown');
        }

        return {
          activated: false,
          reason: 'network_error'
        };
      });
  }

  // ---- Phase 6B: move browser Projects/Homes to the account ----
  //
  // Offered only when BOTH cloud lists were read successfully (the cloud
  // snapshot is active, or the cloud is empty and the local view is kept).
  // The controller only READS the browser copies; they are never changed.
  // When it has an offer to show, it replaces the old Phase 4D.3 legacy
  // prompt, because it also covers pre-sign-in (unscoped) data.
  var migrationMounted = false;
  var migrationController = null;

  function mountMigration(hydration) {
    var el = migrationContainer;

    if (
      !el ||
      !window.MSGCloudMigration ||
      typeof window.MSGCloudMigration.createController !== 'function' ||
      !window.MSGProjects ||
      typeof window.MSGProjects.readLocalForMigration !== 'function' ||
      !hydration ||
      !Array.isArray(hydration.cloudProjects) ||
      !Array.isArray(hydration.cloudHomes) ||
      // Phase 6B #3: the move can only work while account saving is on.
      // Otherwise browser-only work is shown in the "On this device" set
      // and the offer comes back once saving is on again.
      hydration.writes !== 'on'
    ) {
      migrationMounted = false;
      if (el) {
        el.hidden = true;
        el.innerHTML = '';
      }
      return;
    }

    if (!migrationController) {
      migrationController = window.MSGCloudMigration.createController({
        container: el,
        onDone: function () {
          // Re-read the account so moved Projects show from the cloud.
          showUnlockedWithCloud();
        }
      });
    }

    // Phase 6C: kept so a browser Home rename can rebuild the offer.
    lastMigrationCloud = { projects: hydration.cloudProjects, homes: hydration.cloudHomes };

    var migrationState = migrationController.scan(
      hydration.cloudProjects,
      hydration.cloudHomes
    );

    migrationMounted = migrationState !== 'QUIET_NONE';
  }

  function showUnlockedWithCloud() {
    return hydrateCloudReadOnly()
      .then(function (hydration) {
        // Whether the cloud snapshot activated or we safely fell back to
        // customer-scoped browser storage, the existing renderer remains
        // the single UI path.
        mountMigration(hydration);
        showUnlocked();
      });
  }

  // Phase 6C: Home rename controls (event delegation on the page root).
  bindRenameEvents();

  if (!CUSTOMER_ID) {
    showLocked(
      'My Projects is available to signed-in Môdern Studio™ AI+ subscribers. Sign in and upgrade to AI+ to link your Mood Boards and Space Plans together.'
    );
    return;
  }

  if (!PROXY_PATH) {
    showLocked(
      'Could not verify your subscription status right now. Please refresh the page.'
    );
    return;
  }

  fetch(PROXY_PATH)
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      if (data.tier === 'ai_plus') {
        return showUnlockedWithCloud();
      }

      showLocked(
        'My Projects is a Môdern Studio™ AI+ feature — link your Mood Boards and Space Plans together, group rooms into a home, and keep an unlimited project library.'
      );
    })
    .catch(function () {
      showLocked(
        'Could not verify your subscription status right now. Please refresh the page.'
      );
    });
})();